import { MinusCircleOutlined, PlusCircleOutlined, UsergroupAddOutlined } from '@ant-design/icons';
import { Button, DatePicker, Input, InputNumber, Modal, Popover, Select, Switch, TreeSelect } from 'antd';
import React, { useContext, useEffect, useMemo, useState } from 'react'
import { Col, Row } from 'reactstrap';
import './HelperComponent.css'
import Config from '../../../config.json'
import _ from "lodash";
import AppContext from '../../../Context/AppContext';
import axios from 'axios';
import dayjs from 'dayjs';
import { DateRangePickerNew } from './DateRangePickerNew';
import { getPickListOptions } from '../../../tabs/Task/TaskUtil';
import { NewUserPicker } from '../../../common/UserPicker/NewUserPicker';
import { invertColor } from '../../HR/TimeClock/Util'; 
import { NumericFormat } from 'react-number-format';
import AwsServerService from '../../../common/util/AwsServerService';
import HierarchicalDropdown from '../../Roles/HierarchicalDropdown';
import addgroup from '../../../assets/images/svg/addgroup.svg'
import { TreeNode } from 'antd/es/tree-select';
import {useSelector} from 'react-redux'
const { Option, OptGroup } = Select;
export const CriteriaModal = ({ open, setOpen, mainFields, onSave, action, criteriaRows, FromTask, DependacyFilter, DependancyModuleData, allPipelineData }) => {

    const [AllTasks, setAllTasks] = useState([]);

    const [AllDeals, setAllDeals] = useState([])
    const AppData = useContext(AppContext);
    const { dispatch, state } = AppData || {}; 

    const [accounts, setAllAccounts] = useState(state?.AllAccounts || []);
    // const { dispatch ,state} = AppData || {};
    const [rows, setRows] = useState([{ id: Date.now() }]);
    console.log("rows", rows);
    const [error, setError] = useState(false);
    const [criteriaFieldGroups, setCriteriaFieldGroups] = useState({});
    const [lastSelectOptions, setLastSelectOptions] = useState([
        { value: 'Required', label: 'Required' },
        { value: 'Not Required', label: 'Not Required' },
        { value: 'Approved', label: 'Approved' }
    ]);
    const defaultOptions = [
        { value: 'Required', label: 'Required' },
        { value: 'Not Required', label: 'Not Required' },
        // { value: 'Approved', label: 'Approved' }
    ]
    const MiddleOptions = {
        "TEXT": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
            { value: 'Contains', label: 'Contains' },
            { value: 'Not Contains', label: 'Not Contains' },
            { value: 'Starts With', label: 'Starts With' },
            { value: 'Ends With', label: 'Ends With' },
            { value: 'Is Empty', label: 'Is Empty' },
            { value: 'Is Not Empty', label: 'Is Not Empty' },
        ],
        "DEFAULT": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
            { value: 'Contains', label: 'Contains' },
        ],
        "PHONE": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
            { value: 'Contains', label: 'Contains' },
            { value: 'Not Contains', label: 'Not Contains' },
            { value: 'Starts With', label: 'Starts With' },
            { value: 'Ends With', label: 'Ends With' },
            { value: 'Is Empty', label: 'Is Empty' },
            { value: 'Is Not Empty', label: 'Is Not Empty' },
        ],
        "CHECKBOX": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
        ],
        "ROLE": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
        ],
        "BOOLEAN": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
        ],
        "USER": [
            { value: 'Any Of', label: 'Any Of' },
           // { value: 'All Of', label: 'All Of' },
            { value: 'None Of', label: 'None Of' },
            { value: 'Is Empty', label: 'Is Empty' },
            { value: 'Is Not Empty', label: 'Is Not Empty' },
        ],
        "PICKLIST": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
            { value: 'Is Empty', label: 'Is Empty' },
            { value: 'Is Not Empty', label: 'Is Not Empty' },
        ],
        "MULTI-PICKLIST": [
            { value: 'Any Of', label: 'Any Of' },
           // { value: 'All Of', label: 'All Of' },
            { value: 'None Of', label: 'None Of' },
            { value: 'Is Empty', label: 'Is Empty' },
            { value: 'Is Not Empty', label: 'Is Not Empty' },
        ],
        "NUMBER": [
            { value: '=', label: '=' },
            { value: '!=', label: '!=' },
            { value: '<', label: '<' },
            { value: '<=', label: '<=' },
            { value: '>', label: '>' },
            { value: '>=', label: '>=' },
        ],
        "CURRENCY": [
            { value: '=', label: '=' },
            { value: '!=', label: '!=' },
            { value: '<', label: '<' },
            { value: '<=', label: '<=' },
            { value: '>', label: '>' },
            { value: '>=', label: '>=' },
        ],
        "DATE": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
            { value: 'Before', label: 'Before' },
            { value: 'After', label: 'After' },
            { value: 'Between', label: 'Between' },
        ],
        "ATTACHMENT": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
        ],
        "TRANSITION": [
            { value: 'Is', label: 'Is' },
            { value: 'Is Not', label: 'Is Not' },
        ],
    }
    const [lastOptionValues, setLastOptionValues] = useState([]);
    const [middleOptionValues, setMiddleOptionValues] = useState({ ...MiddleOptions });
    const [taskNames, setTaskNames] = useState({});
    const [taskFlowsNmaes, setTaskFlowsNmaes] = useState({});
    useEffect(e => {
        const getAllDealsPages = ()=>{
            const backendUrl = Config.backend_aws_server_url + "catalyApi/getAllDealPages";
            var config = {
                'token': localStorage.getItem('token')
            };
            axios.post(backendUrl, { ...config })
            .then((res) => {
                if (res.data.data) {
                    setAllDeals(res.data.data);
                }
            }).catch(e => {       
            })
        }
        const getTaskNames = async ()=>{
           await AwsServerService.getTaskSubtasksNameWithIds().then(res => {
                setTaskNames(res)
            }).catch(err=>console.log(err))

            await AwsServerService.getAllTaskStatuses().then(res=>{
                setAllTasks(res)
            })
        }
        const getAllTaskFlowsNames = async ()=>{
            await AwsServerService.getAllTaskFlowsNames().then(res => {
                setTaskFlowsNmaes(res[0])
            }).catch(err=>console.log(err))
        }
        getAllTaskFlowsNames();
        getAllDealsPages();
        getTaskNames();
    }, [])

    const requiredFields = ["Deal_Name", "Account_Name", "Closing_Date","Borough","Service_Requested_Name","Zoning_District",
        "Stage", "Amount", "Project_Address","City", "State", "Is_NYC_Project", "Zip_Code","Owner_s_Mailing_Address","Commercial_Overlay",
    "Specials_Districts", "Tidal_Wetlands","Fresh_Water_Wetland","Flood_Hazard",
   "Costal_Erosion_Hazard", "Special_Fire_District", "Landmark_Area", "Environmental_Restriction","Previous_Solar_Application",
"Conjunction", "Stop_Work_Order_Exists_on_Property","Active_Work_Without_Permit_Violations","Asbestos_Required"
,"ACP5_Completed","Asbestos_Inspector_Certificate_Number","NB_Application_Number", "Owner_Type",
"property_Owner_s_Name","Owner_s_First_Name",
"Owner_s_Last_Name","Owner_s_Zip_Code","Owner_s_Email_Address","Owner_Phone_Number", "owner_mailing_Address",
"Non_Profit","DHCR","Other_Owner_Company_Name","Total_Modules",
"Other_Owner_Officer_First_Name","Other_Owner_Officer_Last_Name",
,"Other_Owner_State","Other_Owner_Zip_Code","Other_Owner_Email_Address","Other_Owner_Phone_Number",
"Condo_Company_Name","Condo_Officer_First_Name","Condo_Officer_Last_Name","Condo_City","Condo_State_Name","Condo_Zip_Code","Condo_Email_Address","Condo_Phone_Number",
"Condo_Mailing_Address","Lot_Number","Block_Number","Bin_Number", "Applicant","General_Contractor","Electrician",
"Project_Cost","Total_System_Size","Total_Interconnections","Number_of_Interconnection",
"Certificate_of_Occupancy_Available","ACP5_Control_Number","Interconnection_Application_Number",
"Number_of_Dwelling_Units","NB_Application_Number","Conjunction_Application_Number","Asbestos_Inspector_Certificate_Number",
"Multiple_Dwelling_Classification","Occupancy_Classification_of_Building","Structural_Letter"];
 
    useEffect(() => {
        if(_.isEmpty(mainFields) || !_.isArray(mainFields.Project)) return;
        const requiredSet = new Set(requiredFields);
        const uniqueProjectFieldsMap = new Map();
        mainFields.Project.forEach(fieldObj => {
            if (requiredSet.has(fieldObj.field) && !uniqueProjectFieldsMap.has(fieldObj.field)) {
            uniqueProjectFieldsMap.set(fieldObj.field, fieldObj);
            }
        });
        const filteredFields = {
            ...mainFields,
            Project: Array.from(uniqueProjectFieldsMap.values()),
        };
        setCriteriaFieldGroups(filteredFields);
        }, [mainFields]);
 
    useEffect(e => {
        if (criteriaRows?.length > 0) {
            let arr = [...criteriaRows];
            // if(criteriaFieldGroups["Input Fields"]?.length>0){
            //     arr=arr.filter(k=>{
            //         if(k.group!="Input Fields" || criteriaFieldGroups["Input Fields"]?.find(j=>j.id==k.id)){
            //             return k
            //         }
            //     }) 
            // }
            // if(arr?.length==0){
            //     arr.push({ id: Date.now() });
            // }
            setRows(arr)
        } else {
            setRows([{ id: Date.now() }])
        }
    }, [criteriaRows, action, criteriaFieldGroups, open])
    // const isConditionsCompleted = (isAddRow) => {
    //      
    //     if (rows) {
    //         if (rows.length === 1 && Object.keys(rows[0]).length === 1 && rows[0].id && !isAddRow) {
    //             return true;
    //         }

    //         let arr = rows.filter(row => !row.initial || !row.middel || !row.last);
    //         if (arr?.group && arr?.group?.length > 0 && !["Is Empty", "Is Not Empty"].includes(arr[0].middel)) {
    //             return false
    //         } else {
    //             if (arr?.length > 0 && !["Is Empty", "Is Not Empty"].includes(arr[0].middel)) {
    //                 return true;
    //             }
    //         }

    //     }
    //     return true;
    // }

    const criteriaMap = useMemo(() => {
        const map = {};
        Object.entries(criteriaFieldGroups).forEach(([group, fields]) => {
            fields?.forEach((field) => {
                const key = field.id || field.field;
                map[key] = {
                    ...field,
                    group,
                    type: field.type || field.Type,
                    label: field.label || field.Name,
                };
            });
        });
        return map;
    }, [criteriaFieldGroups]);

    const isConditionsCompleted = (isAddRow) => {
         
        const validateRows = (rowsArray) => {
             
            for (let row of rowsArray) {
                if (row.Group && Array.isArray(row.Group)) {
                    // Recursive check for nested groups
                    const groupIsValid = validateRows(row.Group);
                    if (!groupIsValid) return false;
                } else {
                    const { initial, middel, last } = row;

                    const isSpecialCondition = middel === "Is Empty" || middel === "Is Not Empty";

                    const isValidValue = (value) => {
                        if (typeof value === "string") return value.trim() !== "";
                        if (Array.isArray(value)) return value.length > 0;
                        if (typeof value === "number") return !isNaN(value);
                        if (typeof value === "object" && value !== null) {
                            // For objects, check if it has keys and all values are non-empty
                            return Object.values(value).some(v => isValidValue(v));
                        }
                        return value !== null && value !== undefined;
                    };

                    const isAllValid =
                        isValidValue(initial) &&
                        isValidValue(middel) &&
                        (isSpecialCondition || isValidValue(last));

                    if (!isAllValid) {
                        return false;
                    }

                }
            }
            return true;
        };

        if (!rows || rows.length === 0) return false;

        // Allow one blank row with only id if not adding
        const { initial, middel, last } = rows[0];
        if (
            rows.length === 1 &&
            Object.keys(rows[0]).length === 1 &&
            rows[0].id && initial && middel && last &&
            !isAddRow
        ) {
            return true;
        }

        return validateRows(rows);
    };

    function handleChangeCriteria({ id, row, option, value, type, group }) { 
    if (error) {
        setError(false);
    }
    id = row.id;
    const deepClone = (obj) => JSON.parse(JSON.stringify(obj));
    let clonedRows = deepClone(rows);
 
        const updateById = (arr) => {
            for (let item of arr) {
                if (item.id === id) {
                    item[type] = value;

                if (option && option.type) {
                    item.type = option.type;
                }

                if (group) {
                    item.group = group;
                }

                // 🔁 Initial change logic
                if (type === "initial") {
                    if (!value) {
                        item.middel = "";
                        item.last = "";
                        item.type = "";
                        item.group = "";
                    } else {
                        item.middel = "";
                        item.last = item?.type === "DATE" ? new Date() : "";
                    }
                }
                // 🔁 Middle change logic
                if (type === "middel") {
                    item.last = item?.type === "DATE" ? new Date() : "";

                    if (row?.type === "DATE" && value === "Between") {
                        item.last = {
                                startDate: new Date(),
                                endDate: new Date(),
                                key: "selection"
                            };
                        }
                    }

                    return true; // stop further traversal once updated
                }

                if (item.Group && Array.isArray(item.Group)) {
                    const updated = updateById(item.Group); // recursive check
                    if (updated) return true;
                }
            }

            return false;
        };

        updateById(clonedRows); 
        setRows(clonedRows);
    }

    const handleAddRowGroup = (GroupId, SubGroup, GroupRowId, index) => {
        if (!isConditionsCompleted(true)) {
            setError(true);
            return;
        }
        if (SubGroup) {
            setRows(prevRows => {
                return prevRows.map(item => {
                    if (item.GroupId === GroupId && SubGroup) {
                        return {
                            ...item,
                            Group: item.Group.map(FirstGroup => {
                                if (FirstGroup.id === GroupRowId) {
                                    return {
                                        ...FirstGroup,
                                        Group: [...(FirstGroup.Group || []), { id: Date.now(), condition: "AND" }],
                                        GroupId: Date.now() * 2
                                    };
                                }
                                return FirstGroup;
                            })
                        };
                    }
                    return item;
                });
            });
        } else {
            setRows(prevRows => [
                ...prevRows.slice(0, index + 1),
                {
                    id: Date.now(),
                    condition: "AND",
                    GroupId: Date.now() * 2,
                    Group: [{ id: Date.now() * 3, condition: "AND" }]
                },
                ...prevRows.slice(index + 1)
            ]);

            //setRows([...rows, { id: Date.now(), condition: "AND", GroupId: (Date.now() * 2), Group: [{ id: Date.now()*3, condition: "AND" }] }]);
        }

    };


    const handleAddRow = (SubGroupId) => {
        if (isConditionsCompleted(true)) {
            if (SubGroupId) {
                setRows(prevRows => {
                    // Make a copy of the current state
                    let updatedRows = [...prevRows];
                    // Find the correct group and push a new condition
                    updatedRows.forEach(item => {
                        if (item.Group && item.GroupId === SubGroupId) {
                            item.Group.push({ id: Date.now(), condition: "AND" });
                        } else {
                            item.Group && item.Group.map((subgroup) => {
                                if (subgroup.Group && subgroup.GroupId == SubGroupId) {
                                    subgroup.Group.push({ id: Date.now(), condition: "AND" })
                                }
                            })
                        }
                    });

                    return updatedRows; // Set the new state
                });
            } else {
                setRows([...rows, { id: Date.now(), condition: "AND" }])
            }

        } else {
            setError(true);
        }
    };


    // const handleRemoveRow = (id, keyToRemove) => { 
    //     console.log("rows",rows);

    //     const updatedRows = rows.filter((row) => row.id !== id);
    //     if (keyToRemove == 0) {
    //         if (updatedRows?.length != 0 && updatedRows[0].condition) {
    //             delete updatedRows[0].condition
    //         } else {
    //             updatedRows.push({ id: Date.now() });
    //             setError(false);
    //         }
    //     }
    //     setRows(updatedRows);
    // };

    // const handleRemoveRow = (idToRemove, keyToRemove) => {
    //     const removeById = (items) => { 
    //         return items
    //             .map(item => {
    //                 // If it's a group, we recursively process the nested group array
    //                 if (item.Group && Array.isArray(item.Group)) {
    //                     const updatedGroup = removeById(item.Group);

    //                     // If the group becomes empty after removal, skip the group
    //                     if (updatedGroup.length === 0) return null;

    //                     return { ...item, Group: updatedGroup };
    //                 }

    //                 // Return item if ID doesn't match
    //                 return item.id === idToRemove ? null : item;
    //             })
    //             .filter(Boolean); // Remove null entries
    //     };

    //     const updatedRows = removeById(rows);

    //     // Post-removal check for top-level condition logic
    //     if (keyToRemove === 0) {
    //         if (updatedRows.length > 0 && updatedRows[0].condition) {
    //             delete updatedRows[0].condition;
    //         } else if (updatedRows.length === 0) {
    //             updatedRows.push({ id: Date.now() });
    //             setError(false);
    //         }
    //     }

    //     setRows(updatedRows);
    // };
    const handleRemoveRow = (idToRemove, keyToRemove) => {
         
        let hasGroup = false;

        const checkGroupBeforeRemove = (items) => {
             
            for (let item of items) {
                if (item.id === idToRemove && item.Group && item.Group.length > 0) {
                    hasGroup = true;
                    return;
                }
                if (item.Group && Array.isArray(item.Group)) {
                    checkGroupBeforeRemove(item.Group);
                }
            }
        };

        checkGroupBeforeRemove(rows);

        if (hasGroup) {
            setError("Cannot remove this condition because it contains grouped conditions"); // Show your error UI/toast here
            return;
        } else {
            setError(false);
        }

        const removeById = (items) => {
            return items
                .map(item => {
                    if (item.id === idToRemove) return null;

                    if (item.Group && Array.isArray(item.Group)) {
                        const updatedGroup = removeById(item.Group);
                        return { ...item, Group: updatedGroup };
                    }

                    return item;
                })
                .filter(Boolean);
        };

        const updatedRows = removeById(rows);
        // Post-removal logic
        if (keyToRemove === 0) {
            if (updatedRows.length > 0 && updatedRows[0].condition) {
                delete updatedRows[0].condition;
            } else if (updatedRows.length === 0) {
                updatedRows.push({ id: Date.now() });
                setError(false);
            }
        }
        const cleanEmptyGroups = (arr) => {
            return arr.map(item => {
                // If item has Group and it's an array
                if (Array.isArray(item.Group)) {
                    // Clean Group recursively
                    const cleanedGroup = cleanEmptyGroups(item.Group);

                    // If cleaned group has length, update it
                    if (cleanedGroup.length > 0) {
                        return { ...item, Group: cleanedGroup };
                    } else {
                        // If it's empty, remove Group key entirely or filter out the item
                        const { Group, ...rest } = item;
                        return Object.keys(rest).length > 0 ? rest : null;
                    }
                }
                return item;
            })
                .filter(Boolean);
        };

        const cleanedArray = cleanEmptyGroups(updatedRows);
        if (cleanedArray.length == 0) {
            cleanedArray.push({ id: Date.now() });
        }
        setRows(cleanedArray);
    };


    const getOptions = (row, index) => {
        if ((row[0]?.group == "Project") || (row?.group == "Project")) {
            if (row && row.initial && row.middel && row.initial == 'Account_Name') {
                let arr = _.uniqBy(accounts, row.initial)?.map(account => ({ label: account[row.initial], value: account[row.initial] }))
                return arr;
            } else if (row && row.initial && row.middel && AllDeals) {
                let arr = _.uniqBy(AllDeals, row.initial)?.map(deal => ({ label: deal[row.initial], value: deal[row.initial] }))
                console.log("Project Options", arr.reverse());
                
                return arr.reverse(); // Reverse to show latest deals first
            }
        } else if ((row[0]?.group == "Task") || (row?.group == "Task")) {
             
            if (row && row.initial && row.middel && row.initial == 'TaskStatus') {
                let arr = _.uniqBy(AllTasks, row.initial)?.map(deal => {
                    const node = deal.TaskFlowObject.Nodes.find(label => label.id === deal[row.initial]);
                    const taskStatusText = deal['TaskStatusText']
        .toLowerCase().replace(/\b(\w+)\b/g, (match) => match.charAt(0).toUpperCase() + match.slice(1));    
                    return {
                            label: taskStatusText,
                            name: taskStatusText,
                            value: taskStatusText,
                            color: node ? node.data.color : '#fe8a8aff'
                        }; 
                });
                const uniqueTasks = _.uniqBy(arr, 'label');
                return uniqueTasks;
            } else if (row && row.initial && row.middel && row.initial == 'TaskFlowObject') {
                console.log("taskFlowsNmaes:- ", taskFlowsNmaes)
                 let arr = taskFlowsNmaes.map(flowName => {
                    return {
                        label: flowName?.FlowName || '',
                        name: flowName?.FlowName || '',
                        value: flowName?.FlowName,
                    };
                });
                console.log("TaskFlowObject Options", arr);
                return arr;
            } else if(row && row.initial && row.middel && row.initial == 'PipelineName'){ ;
                let arr = _.uniqBy(allPipelineData, 'PipelineName')?.map(deal => ({
                    label: deal.PipelineName || '',
                    name: deal.PipelineName || '',
                    value: deal.PipelineName || ''
                }));
                 return arr;
            } else if (row && row.initial && row.middel && AllTasks) {
                let arr = _.uniqBy(AllTasks, row.initial)?.map(deal => ({ label: deal[row.initial], value: deal[row.initial] }))
                return arr;
            }
        } else if (row?.group == "Dependancy_Table_Fields") {
             
            if (row && row.initial && row.middel) {
                let arr = _.uniqBy(DependancyModuleData, row.initial)?.map(deal => ({ label: deal[row.initial], value: deal[row.initial] }))
                return arr;
            }
        }
        return defaultOptions;
    }
    const getLastOptionComponent = ({ row, index }) => {

        if (["TEXT", "PHONE", "DEFAULT"].includes(row.type)) {
            return ["Contains", "Starts With", "Ends With"].includes(row.middel) ?
                <><Input
                    style={{ width: "100%", height: 'auto' }}
                    value={row.last}
                    placeholder="Type.."
                    id='last'
                    onChange={(e) => handleChangeCriteria({ row: row, value: e.currentTarget.value, type: 'last', index })}

                /></> :
                ["Is Empty", "Is Not Empty"].includes(row.middel) ? <></> : <Select
                    // mode="multiple"
                    showSearch
                    style={{ width: "100%", height: 'auto' }}
                    value={row.last}
                    placeholder="Select"
                    id='last'
                    onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'last', index })}

                // options={getOptions(row,index)}
                >
                    {row.initial == 'TaskName' ?
                        Object.keys(taskNames)?.map((group, groupIndex) => (
                            <OptGroup key={groupIndex} label={group}>
                                {taskNames[group]?.map((e) => (
                                    <Option key={e?.TaskName} value={e?.TaskName}>
                                        {e?.TaskName}
                                    </Option>
                                ))}
                            </OptGroup>
                        )) :
                        getOptions(row, index)
                            ?.filter(opt => opt.label && opt.label.trim() !== "")
                            //.sort((a, b) => a.label.localeCompare(b.label)) // City Transition Criteria SORT HERE
                            .map(opt => (
                                <Option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </Option>
                            ))}

                </Select>
        } else if (["NUMBER"].includes(row.type)) {
            return [">", "<", ">=", "<="].includes(row.middel) ?
                <><InputNumber
                    style={{ width: "100%", height: 'auto' }}
                    value={row.last}
                    step={1}
                    precision={0}
                    placeholder="Type.."
                    id='last'
                    onChange={(e) => handleChangeCriteria({ row, value: e, type: 'last', index })}

                /></>
                : <Select
                    showSearch
                    // mode="multiple"
                    style={{ width: "100%", height: 'auto' }}
                    value={row.last}
                    placeholder="Select"
                    id='last'
                    onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'last', index })}

                // options={getOptions(row,index)}
                >
                    {getOptions(row, index)
                        ?.filter(opt => opt.label && opt.label.trim() !== "")
                        .map(opt => (
                            <Option key={opt.value} value={opt.value}>
                                {opt.label}
                            </Option>
                        ))}

                </Select>
        } else if (["CURRENCY"].includes(row.type)) {
            return [">", "<", ">=", "<="].includes(row.middel) ?
                <><NumericFormat
                    className="custome-currency-input"
                    name="currency"
                    step={row?.Precision ? Number(row?.Precision) : 1}
                    placeholder="Enter amount"
                    value={row.last}
                    defaultValue={0}
                    thousandSeparator
                    decimalScale={row?.Precision}
                    // decimalsLimit={2} // Sets the precision to 2 decimal places
                    onValueChange={(value) => handleChangeCriteria({ row, value: value.floatValue, type: 'last', index })}
                    prefix="$"
                // intlConfig={{ locale: 'en-US', currency: 'USD' }}
                /></>
                : <Select
                    showSearch
                    // mode="multiple"
                    style={{ width: "100%", height: 'auto' }}
                    value={row.last}
                    placeholder="Select"
                    id='last'
                    onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'last', index })}
                // options={getOptions(row,index)}
                >
                    {getOptions(row, index)
                        ?.filter(opt => opt.label && opt.label.trim() !== "")
                        .map(opt => (
                            <Option key={opt.value} value={opt.value}>
                                {opt.label}
                            </Option>
                        ))}
                </Select>
        } else if (["DATE"].includes(row.type)) {
            return row.middel != "Between" ?
                <><DatePicker
                    onChange={(date, dateString) => {
                        handleChangeCriteria({ row, value: dateString, type: 'last', index })
                    }}
                    style={{ width: "100%", height: 'auto' }}
                    value={dayjs(row.last)}
                    placeholder="Type.."
                    format="MM-DD-YYYY"
                    id='last'
                /></>
                : <>
                    <DateRangePickerNew
                        key={index}
                        onChange={(item) => handleChangeCriteria({ row, value: item, type: 'last', index })}
                        ranges={row.last}
                    />
                </>
        } else if (["BOOLEAN", "CHECKBOX"].includes(row.type)) {
            return <><Select
                showSearch
                // mode="multiple"
                style={{ width: "100%", height: 'auto' }}
                value={row.last}
                placeholder="Select"
                id='last'
                onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'last', index })}
            >
                <Option key={true} value={1}>
                    {"True"}
                </Option>
                <Option key={false} value={-1}>
                    {"False"}
                </Option>
            </Select></>

        } else if (["ROLE"].includes(row.type)) {
            return <HierarchicalDropdown
                styles={{ width: '100%', height: 'auto' }}
                disabledCondition={false}
                key={"rolepicker" + index}
                GroupName={["Zoho", "Role"]}
                handleChangeUser={(value, option) => {
                    handleChangeCriteria({ row, option, value, type: 'last', index })
                    // onChnageRoleUserType({value:value,name:"CcAddress",index:i,field:'CcAddress'})
                }}
                selectedUsers={row.last}
            />
        } else if (["USER"].includes(row.type)) {
            return ["Is Empty", "Is Not Empty"].includes(row.middel) ? <></> : row.initial == 'Account_Name' ?
                <Select
                    mode="multiple"
                    showSearch
                    style={{ width: "100%", height: 'auto' }}
                    value={row.last ? row.last : null}
                    placeholder="Select"
                    id='last'
                    onChange={(e, option) => handleChangeCriteria({ row, option, value: e, type: 'last', index })}
                // options={getOptions(row,index)}
                >
                    {getOptions(row, index)
                        ?.filter(opt => opt.label && opt.label.trim() !== "")
                        .sort((a, b) => a.label.localeCompare(b.label)) // Client Name Transition Criteria SORT HERE
                        .map(opt => (
                            <Option key={opt.value} value={opt.value}>
                                {opt.label}
                            </Option>
                        ))}

                </Select> : <>
                    <NewUserPicker
                        mode="multiple"
                        values={row.last}
                        onChange={d => {
                            handleChangeCriteria({ row, value: d, type: 'last', index })
                        }}
                    /></>

        } else if (["PICKLIST", "MULTI-PICKLIST"].includes(row.type)) {
            let tempOptions = [];
            if (["Is Empty", "Is Not Empty"].includes(row.middel)) {
                return;
            }
            if (row.initial && row.group == "Input Fields") {
                let arr = mainFields["Input Fields"]?.find(k => k.id == row.initial)?.ExtraData;
                if (Array.isArray(arr)) {
                    tempOptions = [...arr];
                }
                return <><Select
                    showSearch
                    mode={`${row.type == "MULTI-PICKLIST" ? "multiple" : ""}`}
                    style={{ width: "100%", height: 'auto' }}
                    value={row.type == "MULTI-PICKLIST" && !row.last ? [] : row.last}
                    placeholder="Select"
                    id='last'
                    onChange={(option) => handleChangeCriteria({ row, option, value: option, type: 'last', index })}
                >
                    {tempOptions?.map((o, i) => {
                        return (<Option key={i} value={o.id}>
                            {o.text}
                        </Option>)
                    })}
                </Select></>
            } else {
                if(row.initial == 'TaskStatus'){
                    tempOptions = row.initial === 'TaskStatus'
                    ? getOptions(row, index)
                    : getPickListOptions("Project_Status", state);
                    
                return <><Select
                    showSearch
                    mode={`${row.type == "MULTI-PICKLIST" ? "multiple" : ""}`}
                    style={{ width: "100%", height: 'auto' }}
                    value={row.type == "MULTI-PICKLIST" && !row.last ? [] : row.last}
                    placeholder="Select"
                    id='last'
                    onChange={(option) => handleChangeCriteria({ row, option, value: option, type: 'last', index })}
                >
                    {tempOptions?.map((o, i) => {
                        return (<Option className="mb-1" style={o.color && { backgroundColor: o.color, color: invertColor(o.color, true) }} key={i} value={o.value}>
                            {o.name}
                        </Option>)
                    })}
                </Select></>
                } else if(row.initial === 'PipelineName'){
                    tempOptions = row.initial === 'PipelineName'
                    ? getOptions(row, index): "";
                    // need to check what we can pass here;
                    
                return <><Select
                    showSearch
                    mode={`${row.type == "MULTI-PICKLIST" ? "multiple" : ""}`}
                    style={{ width: "100%", height: 'auto' }}
                    value={row.type == "MULTI-PICKLIST" && !row.last ? [] : row.last}
                    placeholder="Select"
                    id='last'
                    onChange={(option) => handleChangeCriteria({ row, option, value: option, type: 'last', index })}
                    filterOption={(input, option) =>
                        option?.name?.toLowerCase().includes(input.toLowerCase())
                    }
                >
                    {tempOptions?.map((o, i) => {
                        return (<Option className="mb-1" style={o.color && { backgroundColor: o.color, color: invertColor(o.color, true) }} name={o.name} key={i} value={o.value}>
                            {o.name}
                        </Option>)
                    })}
                </Select></>
                } else if (row.initial === 'TaskFlowObject'){
                    tempOptions = row.initial === 'TaskFlowObject'
                    ? getOptions(row, index) : ""
                    
                return <><Select
                    showSearch
                    mode={`${row.type == "MULTI-PICKLIST" ? "multiple" : ""}`}
                    style={{ width: "100%", height: 'auto' }}
                    value={row.type == "MULTI-PICKLIST" && !row.last ? [] : row.last}
                    placeholder="Select"
                    id='last'
                    onChange={(option) => handleChangeCriteria({ row, option, value: option, type: 'last', index })}
                >
                    {tempOptions?.map((o, i) => {
                        return (<Option className="mb-1" style={o.color && { backgroundColor: o.color, color: invertColor(o.color, true) }} key={i} value={o.value}>
                            {o.name}
                        </Option>)
                    })}
                </Select></>
                }
            }

        } else if (["ATTACHMENT"].includes(row.type)) {
            return <Select
                // mode="multiple"
                showSearch
                style={{ width: "100%", height: 'auto' }}
                value={row.last}
                placeholder="Select"
                id='last'
                onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'last', index })}
            // options={getOptions(row,index)}
            >
                {getOptions(row, index)
                    ?.filter(opt => opt.label && opt.label.trim() !== "")
                    .map(opt => (
                        <Option key={opt.value} value={opt.value}>
                            {opt.label}
                        </Option>
                    ))}

            </Select>
        } else if (["TRANSITION"].includes(row.type)) {
            return <Select
                showSearch
                // mode="multiple"
                style={{ width: "100%", height: 'auto' }}
                value={row.last}
                placeholder="Select"
                id='last'
                onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'last', index })}
            // options={getOptions(row,index)}
            >
                {defaultOptions?.map(opt => {
                    return (<Option key={opt.value} value={opt.value}>
                        {opt.label}
                    </Option>)
                })}
            </Select>
        }
        // default box
        return <><Input
            style={{ width: "100%", height: 'auto' }}
            value={row.last}
            placeholder="Type.."
            id='last'
            onChange={(e) => handleChangeCriteria({ row, value: e.currentTarget.value, type: 'last', index })}
        /></>
    }

    const GroupStrucutre = (Group, index, row, isFirst, isMain) => (
        <div>
            {isMain && <Col sm={1}>
                <div className='Criteria-ToggleButton' style={{ display: 'flex', flexDirection: 'column', width: "70px", alignItems: "center" }}>
                    <div style={{ width: '1px', background: 'black', height: "10px" }}></div>
                    <Switch
                        checked={row.Group[0]?.condition == "AND" ? true : false}
                        checkedChildren={"AND"}
                        unCheckedChildren={"OR"}
                        onChange={(checked, event) => {
                            const condition = checked ? "AND" : "OR";
                            handleChangeCriteria({ row: row.Group[0], value: condition, type: 'condition', index })
                        }}
                    />
                    <div style={{ width: '1px', background: 'black', height: "10px" }}></div>
                </div>
            </Col>}
            <div style={{
                margin: 'auto',
                borderRadius: '5px',
                background: !isFirst ? "#f2f2f2" : "#FFFFFF",
                padding: !isFirst ? "10px 0px 10px 10px" : "10px 0px 10px 15px",
                borderLeft: "1px solid blue",
                width: '95%',
            }}
            >

                {Group?.map((subgroupObject, subIndex, Group) => (
                    <>

                        <Col sm={1}>
                            {(subIndex > 0 || index < 0) && <div className='Criteria-ToggleButton' style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: "70px", alignItems: "center" }}>
                                <div style={{ width: '1px', background: 'black', height: "10px" }}></div>
                                <Switch
                                    checked={row.Group[subIndex]?.condition == "AND" ? true : false}
                                    checkedChildren={"AND"}
                                    unCheckedChildren={"OR"}
                                    onChange={(checked, event) => {
                                        const condition = checked ? "AND" : "OR";
                                        handleChangeCriteria({ row: row.Group[subIndex], value: condition, type: 'condition', index })
                                    }}
                                />
                                <div style={{ width: '1px', background: 'black', height: "10px" }}></div>
                            </div>}
                        </Col>



                        <Row key={subgroupObject.id} style={{ display: "flex", alignItems: "center", justifyContent: !isFirst && "center" }} align="middle">
                            <Col className="pr-0 mr-0" sm={4}>
                                <Select
                                    // mode="multiple"
                                    showSearch
                                    style={{ width: "100%", height: 'auto' }}
                                    placeholder="Select"
                                    value={row.Group[subIndex].initial}
                                    id='initial'
                                    onChange={(e, option) => handleChangeCriteria({ row: row.Group[subIndex], option, value: option.value, type: 'initial', index, group: option.group })}
                                >
                                    {Object.keys(criteriaFieldGroups)?.map((group, groupIndex) => (
                                        <OptGroup key={groupIndex} label={group}>
                                            {group !== "Input Fields"
                                                ? criteriaFieldGroups[group]?.map((e) => (
                                                    <Option key={`${group}-${e.field}`} type={e.type} group={group} value={e?.field}>
                                                        {e?.label}
                                                    </Option>
                                                ))
                                                : criteriaFieldGroups[group]?.map((e) => (
                                                    <Option key={`${group}-${e.id}`} type={e.Type} group={group} value={e?.id}>
                                                        {e?.Name}
                                                    </Option>
                                                ))}
                                        </OptGroup>
                                    ))}

                                </Select>
                            </Col>
                            <Col sm={2}>
                                <Select
                                    // mode="multiple"
                                    showSearch
                                    value={row.Group[subIndex].middel}
                                    style={{ width: "100%", height: 'auto' }}
                                    placeholder="Select"
                                    id='middel'
                                    onChange={(e, option) => handleChangeCriteria({ row: row.Group[subIndex], option, value: option.value, type: 'middel', index })}
                                    options={row.Group[subIndex].type ? middleOptionValues[row.Group[subIndex].type] : middleOptionValues["DEFAULT"]}
                                />
                            </Col>
                            <Col className='p0m0' sm={3}>
                                {getLastOptionComponent({ row: row.Group[subIndex], index })}
                            </Col>
                            <Col className='p0m0' sm={2}>
                                <Button
                                    icon={<MinusCircleOutlined />}
                                    ghost
                                    onClick={() => handleRemoveRow(subgroupObject.id, subIndex)}
                                    style={{ border: "none" }}
                                    danger
                                />
                                <Button
                                    onClick={() => handleAddRow(row.GroupId)}
                                    ghost
                                    icon={<PlusCircleOutlined width={10} height={10} />}
                                    style={{ border: "none", color: "black" }}
                                />

                                {!isFirst && <Button
                                    onClick={() => handleAddRowGroup(row.GroupId, true, subgroupObject.id)}
                                    icon={<UsergroupAddOutlined width={10} height={10} />}
                                    style={{ border: "none" }}
                                />
                                }
                            </Col>
                        </Row>
                        {subgroupObject.Group && GroupStrucutre(subgroupObject.Group, subIndex, subgroupObject, true, true)}
                    </>


                )


                )}


            </div>
        </div >
    )
    return (
        <div>
            <Modal
                open={open}
                // open={false}
                wrapClassName={"Add-criteria-Wrapper"}
                rootClassName="Add-criteria-Root-Wrapper"
                draggable
                title={FromTask ? "Task Filter" : DependacyFilter ? "Dependancy Filter" : "Transition Criteria"}
                maskClosable={false}
                width={600}
                style={{ bottom: '2rem', right: '9rem', zIndex: "1000", minHeight: "" }}
                onCancel={() => setOpen(false)}
                footer={[
                    <div className='Criteria-Footer'>  {error ? <span className='Error' color='red'>
                        {error == true ? "Please fill all required fields." : error}
                    </span> : <span></span>}
                        <Button type="primary" onClick={() => {
                            if (isConditionsCompleted()) {
                                setError(false);
                                onSave(rows)
                                setOpen(false)
                            } else {
                                setError(true);
                            }
                        }}>Save</Button>
                    </div>
                ]}
            >

                {rows.map((row, index) => {
                    return <>
                        {row?.Group ?
                            GroupStrucutre(row?.Group, index, row, false, true)
                            :
                            <>
                                <Col sm={1}>
                                    {index > 0 && <div className='Criteria-ToggleButton' style={{ padding: "0px 5px 0px 5px", display: 'flex', flexDirection: 'column', justifyContent: 'center', width: "70px", alignItems: "center" }}>
                                        <div style={{ width: '1px', background: 'black', height: "10px" }}></div>
                                        <Switch
                                            checked={row?.condition == "AND" ? true : false}
                                            checkedChildren={"AND"}
                                            unCheckedChildren={"OR"}
                                            onChange={(checked, event) => {
                                                const condition = checked ? "AND" : "OR";
                                                handleChangeCriteria({ row, value: condition, type: 'condition', index })
                                            }}
                                        />
                                        <div style={{ width: '1px', background: 'black', height: "10px" }}></div>
                                    </div>}
                                </Col>
                                <Row key={row.id} style={{ display: "flex", alignItems: "center" }} align="middle">

                                    <Col className="pr-0 mr-0" sm={4}>
                                        {FromTask ?
                                            <TreeSelect
                                            showSearch
                                              filterTreeNode={(input, treeNode) =>
                                                            treeNode?.title?.toLowerCase().includes(input.toLowerCase().trim())
                                                        }
                                                style={{ width: '100%', height: 'auto' }}
                                                value={row.initial}
                                                dropdownStyle={{ maxHeight: 400, overflow: 'auto' }}
                                                placeholder={FromTask ? "Select Field":"select Initial"}
                                                id='initial'
                                                allowClear
                                                treeDefaultExpandAll
                                                onChange={(valueObj) => {
                                                        if (!valueObj) {
                                                            handleChangeCriteria({ row, value: null, option: null, type: 'initial', index });
                                                            return;
                                                        }
                                                        const option = criteriaMap[valueObj];
                                                        handleChangeCriteria({ row, option, value: valueObj, type: 'initial', index, group: option?.group,
                                                        });
                                              }}
                                            >
                                                {Object.keys(criteriaFieldGroups)?.map((group, groupIndex) => (
                                                    <TreeNode key={groupIndex} title={group} value={group}>
                                                        {group !== "Input Fields"
                                                            ? criteriaFieldGroups[group]?.map((e) => (
                                                                <TreeNode key={`${group}-${e.id}`}
                                                                    value={e.field || e?.id}
                                                                    title={e.label || e.Name}
                                                                >
                                                                    {e?.label}
                                                                </TreeNode>
                                                            ))
                                                            : criteriaFieldGroups[group]?.map((e) => (
                                                                <TreeNode key={`${group}-${e.id}`} title={e?.label} type={e.Type} group={group} value={ e.field || e?.id}>
                                                                    {e?.Name}
                                                                </TreeNode>
                                                            ))}
                                                    </TreeNode>
                                                ))}
                                            </TreeSelect> :
                                            <Select
                                                // mode="multiple"
                                                showSearch
                                                style={{ width: "100%", height: 'auto' }}
                                                placeholder="Select"
                                                value={row.initial}
                                                id='initial'
                                                onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'initial', index, group: option.group })}
                                            >
                                                {Object.keys(criteriaFieldGroups)?.map((group, groupIndex) => (
                                                    <OptGroup key={groupIndex} label={group}>
                                                        {group !== "Input Fields"
                                                            ? criteriaFieldGroups[group]?.map((e) => (
                                                                <Option key={`${group}-${e.field}`} type={e.type} group={group} value={e?.field}>
                                                                    {e?.label}
                                                                </Option>
                                                            ))
                                                            : criteriaFieldGroups[group]?.map((e) => (
                                                                <Option key={`${group}-${e.id}`} type={e.Type} group={group} value={e?.id}>
                                                                    {e?.Name}
                                                                </Option>
                                                            ))}
                                                    </OptGroup>
                                                ))}

                                            </Select>
                                        }



                                    </Col>
                                    <Col sm={3}>
                                        <Select
                                            // mode="multiple"
                                            showSearch
                                            value={row.middel}
                                            style={{ width: "100%", height: 'auto' }}
                                            placeholder="Select"
                                            id='middel'
                                            onChange={(e, option) => handleChangeCriteria({ row, option, value: option.value, type: 'middel', index })}
                                            options={row.type ? middleOptionValues[row.type] : middleOptionValues["DEFAULT"]}
                                        />
                                    </Col>
                                    <Col className='p0m0' sm={3}>
                                        {getLastOptionComponent({ row, index })}
                                    </Col>
                                    <Col className='p0m0' sm={2}>
                                        <Button
                                            icon={<MinusCircleOutlined />}
                                            ghost
                                            onClick={() => handleRemoveRow(row.id, index)}
                                            style={{ border: "none" }}
                                            danger
                                        />
                                        <Button
                                            onClick={() => { handleAddRow() }}
                                            icon={<PlusCircleOutlined width={10} height={10} />}
                                            style={{ border: "none" }}
                                        />
                                        {/* <Button
                                            onClick={() => handleAddRowGroup(null, null, null, index)}
                                            // icon={<UsergroupAddOutlined width={10} height={10} />}

                                            style={{ border: "none" }}
                                        >
                                            <img src={addgroup} />
                                        </Button> */}
                                        <Button
                                            onClick={() => handleAddRowGroup(null, null, null, index)}
                                            style={{ border: "none" }}
                                            icon={<img src={addgroup} style={{ width: "25px", height: "25px", marginBottom: "5px" }} alt="Add" />}

                                        >

                                        </Button>

                                    </Col>
                                </Row>
                            </>

                        }
                    </>
                })}
            </Modal>
        </div>
    )
}
